import {
  Button,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Stack,
} from "@chakra-ui/react";
import React from "react";
import { CSVLink } from "react-csv";

const ExportTable =  React.memo(({ onPdfClick, headers = [], CSVdata = [] }) => {
  return (
    <Popover>
      <PopoverTrigger>
        <Button
          color={"#fff"}
          bg={"#FFBF00"}
          _hover={{ bg: "#FFBF0099" }}
          fontWeight={"bold"}
          h={8}
        >
          Export
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent w={"120px"}>
          <PopoverArrow />
          <PopoverBody>
            <Stack align={"flex-start"}>
              <Button variant={"link"} onClick={onPdfClick}>
                PDF
              </Button>
              <CSVLink data={CSVdata} headers={headers}>
                <Button variant={"link"}>Excel/CSV</Button>
              </CSVLink>
            </Stack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
});

export default ExportTable;
